import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { InfoCircleIcon } from '@gemini/icons';
const DESKTOP_WIDTH = '280px';
const MOBILE_WIDTH = '100%';
const StandaloneErrorCard = ({ t }) => (_jsxs(Box, { backgroundColor: "color.background.default", borderColor: "color.background.subdued", borderRadius: "radius.16", borderStyle: "solid", borderWidth: "borderWidth.1", columnGap: "spacing.8", display: "flex", flexDirection: "row", paddingHorizontal: "spacing.6", paddingVertical: "spacing.16", width: {
        'breakpoint.base': MOBILE_WIDTH,
        'breakpoint.lg': DESKTOP_WIDTH,
    }, children: [_jsx(InfoCircleIcon, {}), t('wlac_pricepages_missing_agency')] }));
export default StandaloneErrorCard;
